module.exports = __webpack_public_path__ + "static/img/全球司库管理云6.d98a84db.png";